module.exports = __webpack_public_path__ + "img/03n.6e2494fe.png";